module.exports = __webpack_public_path__ + "media/assets/images/Card_3-2e3dd0d2a0b177a01c462cc1443dca3f.png";